import { Controller } from "@hotwired/stimulus";
import Tracker from "@openreplay/tracker";

export default class extends Controller {
  static values = {
    config: Object,
    user: Object,
  };

  connect() {
    if (!this.hasConfigValue) return;

    this.tracker = window.OpenReplayTracker;

    if (!this.tracker) {
      this.tracker = new Tracker(this.configValue);
      this.tracker.start();
      window.OpenReplayTracker = this.tracker;
    }

    this.applyUserContext();
  }

  disconnect() {}

  applyUserContext() {
    if (!this.tracker || !this.hasUserValue) return;

    const userData = this.userValue;
    if (userData.userID) {
      this.tracker.setUserID(userData.userID);
    }

    if (userData.metadata) {
      Object.entries(userData.metadata).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          this.tracker.setMetadata(key, value);
        }
      });
    }
  }
}
